import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { AccountService } from "@/services/AccountService"
import { ImbpService } from "@/services/ImbpService"
import { MeterpointService } from "@/services/MeterpointService"
import { RtsStatusService } from "@/services/RtsStatusService"
import { FeaturesService } from "@/services/admin/FeaturesService"

export const getRtsMeters = (accountNumber: string) => {
  const queries = new QueryAggregator()
  const isNewRtsEnabled =
    FeaturesService.isFeatureActive("TMP_SO_23897_RTS_METER_SYNC") === true

  if (isNewRtsEnabled) {
    const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
    queries.add(coreIdQuery)

    if (coreIdQuery.data) {
      const rtsStatusQuery = RtsStatusService.hasRtsMetersByCoreId(
        coreIdQuery.data,
      )
      queries.add(rtsStatusQuery)

      let hasUpcomingMeterExchangeQuery
      if (rtsStatusQuery.data) {
        hasUpcomingMeterExchangeQuery = ImbpService.hasUpcomingMeterExchange(
          coreIdQuery.data,
        )
        queries.add(hasUpcomingMeterExchangeQuery)
      }

      return queries
        .setData({
          hasRtsMeters: rtsStatusQuery.data ?? false,
          hasUpcomingMeterExchange: hasUpcomingMeterExchangeQuery?.data,
        })
        .getAggregate()
    }

    return queries
      .setData({ hasRtsMeters: false, hasUpcomingMeterExchange: undefined })
      .getAggregate()
  }

  let hasUpcomingMeterExchangeQuery
  const meterpointQuery = MeterpointService.getForAccount(accountNumber)
  queries.add(meterpointQuery)

  const tradMetersSerialNumber = meterpointQuery.data.reduce(
    (smartMeterSerialNumber, meterpoint) => {
      if (meterpoint.supplyStatus !== "NotSupplied") {
        meterpoint.meters?.forEach((meter) => {
          if (!meter.isSmartMeter && meter.identifier) {
            smartMeterSerialNumber.push(meter.identifier)
          }
        })
      }
      return smartMeterSerialNumber
    },
    [] as string[],
  )

  const rtsMetersQuery = MeterpointService.getRtsMeters(tradMetersSerialNumber)

  if (rtsMetersQuery.data) {
    const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
    queries.add(coreIdQuery)

    if (coreIdQuery.data)
      hasUpcomingMeterExchangeQuery = ImbpService.hasUpcomingMeterExchange(
        coreIdQuery.data,
      )

    queries.add(hasUpcomingMeterExchangeQuery)
  }

  return queries
    .setData({
      hasRtsMeters: rtsMetersQuery.data,
      hasUpcomingMeterExchange: hasUpcomingMeterExchangeQuery?.data,
    })
    .getAggregate()
}
